import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import MessageType from '../../../enums/MessageType';
import Language from '../../lang/language';
import Translation from '../../lang/Translation';
import {getSettings} from '../../selectors/selectors';
import Message from '../ui/Message/Message';

const useStyles = createUseStyles({
  addressHelpMessage: {
    marginBottom: '1em',
  },
});

export function AddressHelpMessage(props) {
  const classes = useStyles();
  
  const translationKey = `deliveryAddress.helpMessage.${props.country}`;
  
  if (!Language.doesTranslationExist(translationKey) || props.disableAddressHelpMessage) return null;
  
  return (
    <div className={classes.addressHelpMessage} data-test="AddressHelpMessage">
      <Message type={MessageType.INFO}>
        <Translation>{translationKey}</Translation>
      </Message>
    </div>
  );
}

AddressHelpMessage.propTypes = {
  country: PropTypes.string.isRequired,
  disableAddressHelpMessage: PropTypes.bool,
};

const mapStateToProps = state => ({
  disableAddressHelpMessage: getSettings(state).disable_address_help_message,
});

export default connect(mapStateToProps)(AddressHelpMessage);
